import {batch, fetch as fetchBase} from '@logistics-frontend/core/utils/network'

import {withPassportRedirect} from './middleware'
import {addCorpHeaders} from './middlewares'

/** @deprecated используйте clientFetch из src/api/fetch */
export const fetch = batch(withPassportRedirect(addCorpHeaders(fetchBase)))
